import { useState } from "react";

import { EyeIcon, TrashIcon, VideoCameraIcon } from "@heroicons/react/24/outline";

import Modal from "../../layouts/Modal";
import { IPartImage } from "../../models/Part";
import classNames from "../../utils/classNames";

interface PartImageThumbProps {
  video: IPartImage;
  index: number;
  handleRemove: (id: string) => void;
}

export function PartVideoThumb({ video, index, handleRemove }: PartImageThumbProps) {
  const [previewOpen, setPreviewOpen] = useState<boolean>(false);

  return (
    <>
      <Modal open={previewOpen} width={"max-w-7xl"} setOpen={setPreviewOpen} >
        <div className="w-full h-full flex justify-center items-center">
          <video width="1024" height="576" controls>
            <source src={video.url} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
      </Modal>
      <div
        key={`part-video-${index}`}
        className="text-center relative w-36 h-36 snap-start"
      >
        <div className="relative w-full h-full flex justify-center aspect-square z-0 hover:opacity-60">
          <VideoCameraIcon className="w-2/3 rounded-sm object-contain" />

          {/* Hover area */}
          <div className="opacity-0 flex flex-col justify-between z-20 absolute top-0 right-0 bottom-0 left-0 p-2 rounded-[6px] text-white font-bold bg-[rgba(0,0,0,0.75)] hover:opacity-100">
            <div className="flex grow items-center justify-center">
              <EyeIcon className="h-8 w-8 cursor-pointer hover:scale-125" onClick={() => setPreviewOpen(true)} />
            </div>
            <aside className="flex justify-between">
              <TrashIcon className="h-8 w-8 cursor-pointer hover:scale-125" onClick={() => handleRemove(video.id)} />
            </aside>
          </div>

        </div>
      </div>
    </>
  );
}
